import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { useContent } from "@/content/ContentContext";

const ease = [0.22, 1, 0.36, 1];

const FALLBACK_CERTS = [
  { code: "IS 4984", label: "HDPE Pipes Certified" },
  { code: "IS 4985", label: "PVC Pipes Certified" },
  { code: "IS 14151", label: "Sprinkler Systems Certified" },
  { code: "ISO 9001:2015", label: "Quality Management" },
  { code: "PMKSY", label: "Subsidy-Ready Designs" },
];

export default function Certifications() {
  const content = useContent();
  const CERTS = content.certifications && content.certifications.length ? content.certifications : FALLBACK_CERTS;
  return (
    <section data-testid="certifications-section" className="border-t border-line">
      <div className="mx-auto max-w-[1440px] px-6 py-16 lg:px-12 lg:py-20">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease }}
          className="text-center text-xs uppercase tracking-[0.3em] text-harvest"
        >
          Certifications &amp; Standards
        </motion.p>
        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-testid="certifications-grid">
          {CERTS.map((c, i) => (
            <motion.div
              key={c.code}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.06, ease }}
              data-testid={`cert-${c.code.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex flex-col items-center border border-line bg-moss px-4 py-6 text-center"
            >
              <BadgeCheck className="h-6 w-6 text-harvest" strokeWidth={1.5} />
              <p className="mt-3 font-display text-lg font-semibold tracking-tight text-cream">{c.code}</p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.15em] text-sage">{c.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
